import React, { useState, useEffect } from 'react';
import { Nav, OverlayTrigger, Tooltip } from 'react-bootstrap';
import ManagerSidebarItems from './ManagerSidebarItems';
import { MenuLogo, ReportIssueLogo } from '../Sidebar/SidebarLogos';
import ReportIssue from '../Sidebar/ReportIssue';

const ManagerSidebar = () => {
  const [sidebarShow, setSidebarShow] = useState(true);
  const [reportModalShow, setReportModalShow] = useState(false);

  const handleShowSidebar = () => {
    setSidebarShow(!sidebarShow);
  };

  const handleOpenReportModal = () => {
    setReportModalShow(true);
  };

  const handleCloseReportModal = () => {
    setReportModalShow(false);
  };


  useEffect(() => {
    const width = window.innerWidth
    if (width <= 820) {
      setSidebarShow(false)
    }
  }, [])

  return (
    <>
      <div className={`AdminDashboard ${sidebarShow ? 'show' : ''}`}>
        <div className="sidebar-title">
          <button className="sidebar-toggle" onClick={handleShowSidebar}>
            <MenuLogo />
          </button>
        </div>
        <ManagerSidebarItems />
        <Nav as="ul" className="nav-item-report-issue">
          <Nav.Item as="li" className="m-0">
            {sidebarShow ? (
              <Nav.Link onClick={handleOpenReportModal}>
                <span className="nav-icon">
                  <ReportIssueLogo />
                </span>
                <span className="toggle-name">Report Issue</span>
              </Nav.Link>
            ) : (
              <OverlayTrigger
                key="nav-report"
                placement="right"
                overlay={<Tooltip id="nav-report">Report Issue</Tooltip>}
              >
                <Nav.Link onClick={handleOpenReportModal}>
                  <span className="nav-icon">
                    <ReportIssueLogo />
                  </span>
                  <span className="toggle-name">Report Issue</span>
                </Nav.Link>
              </OverlayTrigger>
            )}
          </Nav.Item>
        </Nav>
      </div>
      <ReportIssue openReportIssue={reportModalShow} onClose={handleCloseReportModal} />
    </>
  );
};

export default ManagerSidebar;
